import type { UiActionName } from "./telemetryEvents";

/** Spread onto a control so pressing it starts a Faro user action that links the work it triggers. */
export const userAction = (name: UiActionName) => ({ "data-faro-user-action-name": name });
